export default "__VITE_ASSET__4027e81b__"